import { useCallback, useState } from 'react';
import { Box, InputBase, makeStyles } from '@material-ui/core';
import { AutoCompleteSelect } from '../../../../components';
import Dialog from '../../../../components/Dialog';
import { Checkbox } from '../../../DutyAssign/components/Attendance/Setting';
import { NEW_BED_STATUS_CUBICLE_ITEM_LIST } from '../../../../comm/constant';

const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: '#7d86a9',
  },
  star: {
    color: '#ff0000',
  },
  input: {
    width: '100%',
    height: '3.5rem',
    padding: '1.25rem',
    border: 'solid 1px #e4e7eb',
    borderRadius: '10px',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
  },
  content: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
  },
}));

const EditRemark = ({ data, handleClose, handleConfirm, haveColor = true }) => {
  const classes = useStyles();
  const [form, setForm] = useState({
    remark: data.remark,
    color: data.color,
    active: data.active,
    id: data.id,
  });

  const handleChange = useCallback(
    (type) => (e) => {
      switch (type) {
        case 'remark':
          setForm((o) => ({
            ...o,
            remark: e.target.value,
          }));
          break;
        case 'color':
          setForm((o) => ({
            ...o,
            color: e,
          }));
          break;
        case 'active':
          setForm((o) => ({
            ...o,
            active: !o.active,
          }));
          break;

        default:
          break;
      }
    },
    []
  );

  // 提交表单
  const handleSubmit = useCallback(() => {
    handleConfirm(form);
  }, [handleConfirm, form]);

  return (
    <Dialog
      open={true}
      title="Edit Remarks"
      cancel="Cancel"
      confirm="Confirm"
      cancelStyle={{ border: 'unset' }}
      handleCancel={handleClose}
      handleClose={handleClose}
      handleConfirm={handleSubmit}
    >
      <Box display="flex" flexDirection="column" gridGap="1.25rem">
        <Box display="flex" flexDirection="column" gridGap="0.75rem">
          <div className={classes.title}>Remarks name</div>
          <InputBase className={classes.input} value={form.remark} onChange={handleChange('remark')} />
        </Box>
        {haveColor && (
          <Box display="flex" flexDirection="column" gridGap="0.75rem">
            <div className={classes.title}>Color</div>
            <AutoCompleteSelect
              type="color"
              itemList={NEW_BED_STATUS_CUBICLE_ITEM_LIST.RemarkColor}
              value={form.color}
              onChange={handleChange('color')}
              colorIconBorder="solid 1px #e4e7eb"
            />
          </Box>
        )}
        <Box display="flex" alignItems="center" gridGap="0.75rem">
          <Checkbox check={form.active} handleChange={handleChange('active')} />
          <div className={classes.content}>ACTIVE</div>
        </Box>
      </Box>
    </Dialog>
  );
};

export default EditRemark;
